import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './Assets/css/animate.min.css'
import './Assets/css/bootstrap.min.css'
import './Assets/css/style.css'
import './Assets/css/responsive.css'
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);